export enum CustomerGroupType {
  EatIn = 'EatIn',
  TakeAway = 'TakeAway',
  Student = 'Student',
  StaffVisitor = 'StaffVisitor',
  StudentEatIn = 'StudentEatIn',
  StaffVisitorEatIn = 'StaffVisitorEatIn',
  StudentTakeAway = 'StudentTakeAway',
  StaffVisitorTakeAway = 'StaffVisitorTakeAway',
  Other = 'Other',
}
